import { IAnnotatedTask } from '@/services/custom/type';
import { Progress } from 'antd';
import type { FC } from 'react';
import { useAnnotatedTaskId } from '../../stores';

export const Card: FC<{ dataSource: IAnnotatedTask }> = (props) => {
  // props
  const { dataSource } = props;
  const {
    annotated_task_id,
    node_name,
    create_time,
    annotated_progress,
    annotated_count,
    un_annotated_count,
  } = dataSource;
  // shared state
  const [activeId, setActiveId] = useAnnotatedTaskId();

  return (
    <li
      className={`flex flex-col gap-2 px-4 py-3 border border-bc rounded-md cursor-pointer transition group ${
        annotated_task_id == +activeId
          ? 'bg-active'
          : 'hover:bg-selected hover:shadow-md active:bg-active'
      }`}
      onClick={() => setActiveId(+annotated_task_id)}
    >
      <p className="text-sm font-medium text-main transition group-hover:text-primary">
        {node_name}
      </p>
      <p className="tex-xs text-secondary-2">创建时间：{create_time}</p>
      <div className="flex flex-col gap-1">
        <p className="text-sm text-primary">{annotated_progress}%</p>
        <Progress percent={annotated_progress} showInfo={false} />

        <p className="flex justify-between text-xs text-secondary-2">
          <span className="text-primary">已标注{annotated_count}</span>
          <span>未标注{un_annotated_count}</span>
        </p>
      </div>
    </li>
  );
};
